import { Operator } from '../operators/operator';
export const filterNonNumbers = (value) => value.replace(/\D/g, '');
export const formatDollars = (dollars) => dollars.toString().replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
export const formatCurrency = (dollars) => dollars.toString().replace(/\D/g, '');
export const formatCents = (cents) => {
    const formattedCents = cents.toString().substring(0, 2);
    if (formattedCents.length === 0) {
        return '00';
    }
    if (formattedCents.length === 1) {
        return `${formattedCents}0`;
    }
    return formattedCents;
};
/**
 * Formats a number or string value as a dollar amount
 *
 * @param value - value to be formatted
 * @param prefix - string to prepend to the dollar amount, default = '$'
 *
 * @returns formatted dollar string
 */
export const dollarFormatter = (value = 0, prefix = '$') => {
    const dollarParts = value.toString().split('.');
    const dollars = Operator(dollarParts[0] || '')
        .pipe(filterNonNumbers, formatDollars);
    const cents = Operator(dollarParts[1] || '')
        .pipe(filterNonNumbers, formatCents);
    // Account for negative numbers
    if (Number(value) < 0) {
        return `-${prefix}${dollars}.${cents}`;
    }
    return `${prefix}${dollars}.${cents}`;
};
// This can be removed with the updates to the dollarFormatter - JR 03/25/2021
export const currencyFormatter = (value = 0) => {
    const dollarParts = value.toString().split('.');
    const dollars = Operator(dollarParts[0] || '')
        .pipe(filterNonNumbers, formatDollars);
    const cents = Operator(dollarParts[1] || '')
        .pipe(filterNonNumbers, formatCents);
    return `${dollars}.${cents}`;
};
export const roundedDollarFormatter = (value = 0) => {
    const dollarParts = value.toString().split('.');
    const dollars = Operator(dollarParts[0] || '')
        .pipe(filterNonNumbers, formatDollars);
    return `$${dollars}`;
};
/**
 * Formats a number or string value as a dollar amount, in place
 *
 * @remarks
 * Generally used on Inputs to format the amount as the user types
 *
 * @param value - dollar amount
 * @param prefix - string to prepend to the dollar amount, default = '$'
 *
 * @returns formatted dollar string
 */
export const transientDollarFormatter = (value = 0, prefix = '$') => {
    const dollarValue = value === '.' ? 0 : value;
    const containsDecimal = dollarValue.toString().includes('.');
    const dollarParts = dollarValue.toString().split('.');
    const dollars = Operator(dollarParts[0] || '')
        .pipe(filterNonNumbers, formatDollars);
    const cents = Operator(dollarParts[1] || '')
        .pipe(filterNonNumbers, (v) => v.substring(0, 2));
    if (cents.length !== 0) {
        return `${prefix}${dollars}.${cents}`;
    }
    if (containsDecimal) {
        return `${prefix}${dollars}.`;
    }
    return `${prefix}${dollars}`;
};
// This can be removed with the updates to the transientDollarFormatter - JR 03/25/2021
export const transientCurrencyFormatter = (value) => {
    const containsDecimal = value.toString().includes('.');
    const dollarParts = value.toString().split('.');
    const dollars = Operator(dollarParts[0] || '')
        .pipe(filterNonNumbers, formatCurrency);
    const cents = Operator(dollarParts[1] || '')
        .pipe(filterNonNumbers, (v) => v.substring(0, 2));
    if (cents.length !== 0) {
        return `${dollars}.${cents}`;
    }
    if (containsDecimal) {
        return `${dollars}.`;
    }
    return `${dollars}`;
};
export const reverseDollarFormatter = (value) => {
    const numRegex = /[^\d.-]/g;
    const formattedAmount = value.replace(numRegex, '');
    try {
        return Number(formattedAmount);
    }
    catch (err) {
        console.error(err);
        return 0;
    }
};
export const dollarToStringFormatter = (value) => Operator(value)
    .pipe(dollarFormatter, (v) => v.toString().replace('$', ''));
export const roundUpToNearestCent = (value) => {
    if (isNaN(value)) {
        return 0;
    }
    const textValue = value.toString();
    const textValueArray = textValue.split('.');
    if (textValueArray.length < 2 || textValueArray[1].length < 3) {
        return value;
    }
    else {
        return Math.ceil(value * 100) / 100;
    }
};
/**
 * Formats a number or string value as a dollar amount, in place
 *
 * @remarks
 * Generally used on Inputs to format the amount as the user types
 *
 * @param value - dollar amount
 *
 * @returns formatted dollar string
 */
export const convertDollarStringToNumberInPlace = (value = 0) => {
    const dollarValue = value === '.' ? 0 : value;
    const containsDecimal = dollarValue.toString().includes('.');
    const dollarParts = dollarValue.toString().split('.');
    const dollars = Operator(dollarParts[0] || '')
        .pipe(filterNonNumbers, formatDollars);
    const cents = Operator(dollarParts[1] || '')
        .pipe(filterNonNumbers, (v) => v.substring(0, 2));
    if (cents.length !== 0) {
        return `${dollars}.${cents}`;
    }
    if (containsDecimal) {
        return `${dollars}.`;
    }
    return `${dollars}`;
};
